import { PortfolioInboxes } from "@/Common/Models/UI/Enums";
import { BaseComponentRegistry } from "@/Common/Modularity/BaseComponentRegistry";
import { createRegistryListView } from "@/Common/Modularity/Components/ComponentRegistryWrapper";

/**
 * Component IDs by rendering priority in the portfolio forms menu section registry.
 */
enum PortfolioFormsMenuSectionRegistryComponentId {
    Cnesst
}

/**
 * Props for the portfolio forms menu section registry.
 */
interface IPortfolioFormsMenuSectionRegistryProps {
    currentInbox: PortfolioInboxes;
}

/**
 * Portfolio forms menu section component registry.
 */
class PortfolioFormsMenuSectionRegistry extends BaseComponentRegistry<PortfolioFormsMenuSectionRegistryComponentId, IPortfolioFormsMenuSectionRegistryProps> {}

/**
 * Portfolio forms menu section React component.
 */
const PortfolioFormsMenuSectionRegistryView = createRegistryListView(() => PortfolioFormsMenuSectionRegistry.getInstance());

export {
    IPortfolioFormsMenuSectionRegistryProps,
    PortfolioFormsMenuSectionRegistry,
    PortfolioFormsMenuSectionRegistryComponentId,
    PortfolioFormsMenuSectionRegistryView
};
